import { Chip, Text } from 'components';
import PlanStat from './PlanStat';
import { TEXT_STRING } from '../../../constants';

type Plan = {
  name: string;
  price: string;
  description: string;
  caution?: string;
  chipText?: string;
  priceNotes: string;
  girlCount: string;
  usageTime: string;
  extension?: string;
  addPrice?: string;
};

type Props = {
  plan: Plan;
  index: number;
};

const MENU_STR = TEXT_STRING.PRICE_LIST;

const planVariantByIndex = (i: number) => {
  switch (i) {
    case 0:
      return { border: 'border-success', chip: 'bg-success' };
    case 1:
      return { border: 'border-primary', chip: 'bg-primary' };
    case 2:
      return { border: 'border-[#17a2b8]', chip: 'bg-[#17a2b8]' };
    default:
      return { border: 'border-neutral-300', chip: 'bg-transparent' };
  }
};

export default function PlanCard({ plan, index }: Props) {
  const variant = planVariantByIndex(index);

  return (
    <div
      id={`plan-card-${index}`}
      className={
        `relative bg-white flex flex-col gap-2 rounded-xl p-5 border-2 my-4 ` +
        variant.border
      }
    >
      {plan.chipText && (
        <Chip
          className="absolute top-3 right-3 !ring-0 font-medium"
          textColor="text-white"
          padding="px-4 py-1"
          textSize="text-[10px]"
          rounded="rounded-full"
          bgColor={variant.chip}
        >
          {plan.chipText}
        </Chip>
      )}
      <Text fontWeight="font-bold" textColor="text-neutral-700" fontSize={18}>
        {plan.name}
      </Text>
      <Text
        fontWeight="font-semibold"
        textColor="text-neutral-550"
        fontSize={12}
      >
        {plan.description}
      </Text>
      {plan.caution && (
        <Text
          fontWeight="font-semibold"
          textColor="text-neutral-550"
          fontSize={10}
        >
          {plan.caution}
        </Text>
      )}
      <div className="flex justify-between items-center">
        <Text fontWeight="font-bold" textColor="text-primary" fontSize={18}>
          {plan.price}
        </Text>
        <Text
          fontWeight="font-semibold"
          textColor="text-neutral-550"
          fontSize={10}
        >
          {plan.priceNotes}
        </Text>
      </div>

      <div className="flex bg-neutral-25 p-2 rounded">
        <PlanStat head={MENU_STR.GIRL_COUNT_HEAD} value={plan.girlCount} />
        <PlanStat head={MENU_STR.USAGE_TIME_HEAD} value={plan.usageTime} />
        <PlanStat
          head={
            plan.extension ? MENU_STR.EXTENSION_HEAD : MENU_STR.ADD_PRICE_HEAD
          }
          value={plan.extension ?? plan.addPrice}
        />
      </div>
    </div>
  );
}
